const initialState = {
  data: [],
}

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
      case 'UPDATE_ALERT': {
          return {
              data: action.payload,
          }
      }

      default:
          return state;
  }
}

export default alertReducer;
